import React from "react"
import { connect } from "react-redux"

import { dashboardKnowledgeSearchRequest } from "../../../actions/dashboard-actions"

const KnowledgeSearch = ({ searchTerm, requestSearch }) => (
    <div className="widget">
        <h3 className="widget-header">
            <span className="icon icon-search" />
            Quick Search
        </h3>
        <div className="widget-content" style={{ position: "relative" }}>
            <span className="searchicon">
                <input
                    type="text"
                    name="title"
                    className="form-control"
                    placeholder="Search"
                    onChange={requestSearch}
                    value={searchTerm}
                />
            </span>
        </div>
    </div>
)

const mapStateToProps = ({ presentation: { dashboard } }) => ({
    searchTerm: dashboard.workingFilterModel.title
})

const mapDispatchToProps = dispatch => ({
    requestSearch: ({ target: { name, value } }) =>
        dispatch(dashboardKnowledgeSearchRequest(name, value))
})

export default connect(mapStateToProps, mapDispatchToProps)(KnowledgeSearch)
